import gql from 'graphql-tag'

export default gql`
query searchEvent($event: String!) {
  labels(
    sort: _ID_DESC
    filter: { data: { eventName: $event } } 
  ) {
    _id
    referenceId
    seq
    last
    data
    recipient
    address
    app
    group
    tracking {
      _id
      carrier
      code
      sendHook
      scannedAt
      status
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/searchEvent.js